// extracted by mini-css-extract-plugin
export default {"errorMsg":"InputValidationError_errorMsg__p7Dzt"};